<template>
  <BaseBlock title="Formulaire de réinitialisation de mot de passe">
    <v-form v-model="valid" ref="form">
      <BaseAlert :error="error" />
      <div v-if="ifFalseToken">
        <v-row>
          <v-col class="py-0" cols="6">
            <v-text-field
              v-model="formulaire.mdp"
              label="Nouveau mot de passe"
              @input="resetApiErrors('mdp')"
              :error-messages="checkApiErrors('mdp')"
              :rules="passwordRules"
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show1 ? 'text' : 'password'"
              @click:append="show1 = !show1"
              outlined
              shaped
              required
            ></v-text-field>
          </v-col>
          <v-col class="py-0" cols="6">
            <v-text-field
              v-model="formulaire.mdpConfirm"
              label="Confirmation nouveau mot de passe"
              @input="resetApiErrors('mdpConfirm')"
              :error-messages="checkApiErrors('mdpConfirm')"
              :rules="passwordConfirmRules"
              :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show2 ? 'text' : 'password'"
              @click:append="show2 = !show2"
              outlined
              shaped
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <div class="text-center">
              <v-btn
                class="mx-2"
                color="primary"
                @click="newPassword"
                :disabled="!valid"
                >Valider</v-btn
              >
            </div>
          </v-col>
        </v-row>
      </div>
      <div v-else-if="ifActionFinish">
        Votre mot de passe a été réinitialisé
      </div>
      <div v-else>{{ erreurMessage }}</div>
    </v-form>
  </BaseBlock>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";
import BaseForm from "@/components/base/BaseForm";
import ApiGestionCompte from "@/repositories/ApiGestionCompte";
import BaseAlert from "@/components/base/BaseAlert";

export default {
  name: "NewPasswordPage",
  components: { BaseBlock, BaseAlert },
  props: ["token"],
  extends: BaseForm,
  data() {
    return {
      formulaire: {
        mdp: "",
        mdpConfirm: "",
        tokenMail: "",
      },
      message: null,
      erreurMessage: "Lien invalide",
      ifFalseToken: true,
      ifActionFinish: false,
      show1: false,
      show2: false,
      pattern:
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#?$%^&*=+;:.])(?=.{10,})/,
      passwordRules: [
        (v) =>
          this.pattern.test(v) ||
          "Min. 10 caractères avec au moins une majuscule, une minuscule, un chiffre et un caractère spécial !@#?$%^&*=+;.:",
      ],
      passwordConfirmRules: [
        (v) => !!v || "La confirmation du mail est requise",
        (v) =>
          this.formulaire.mdp == v ||
          "Les deux mots de passes ne correspondent pas",
      ],
    };
  },
  async created() {
    this.formulaire.tokenMail = this.token;
    try {
      await ApiGestionCompte.checkToken(this.formulaire);
    } catch (error) {
      this.ifFalseToken = false;
      this.populateErrors(error);
    }
  },
  methods: {
    async newPassword() {
      try {
        await ApiGestionCompte.changePassword(this.formulaire);
        this.ifFalseToken = false;
        this.ifActionFinish = true;
      } catch (error) {
        this.populateErrors(error);
      }
    },
  },
};
</script>
